import { toNumber } from "lodash";

export const isNumberValid = (value: string | number | undefined) =>
    value !== null && isFinite(toNumber(value)); // toNumber converts null to 0
export const isZipCodeValid = (value: string) => /^[a-zA-Z0-9 -]+$/.test(value);
export const isEmailValid = (value: string) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
export const isValidUUID = (value?: string) => {
    if (!value) return false;
    const regexExp =
        /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
    return regexExp.test(value);
};
export const isTimeValid = (value?: string) =>
    value &&
    /^(?:[0-1]?[0-9]|2[0-3]):[0-5][0-9](?:[:][0-5][0-9])?$/.test(value);
export const isUrlValid = (value: string) =>
    /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi.test(
        value
    );
export const isBase64ImageValid = (value?: string) =>
    value &&
    /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/.test(
        value
    );

const ACCEPTED_CSV_MIME_TYPES = [
    "text/csv",
    "application/csv",
    "application/vnd.ms-excel",
    "text/plain",
];
export const isAcceptedCsvFile = (file?: File) =>
    !!file &&
    (ACCEPTED_CSV_MIME_TYPES.includes(file.type) ||
        file.type === "" ||
        file.name.toLowerCase().endsWith(".csv"));

export const isJson = (string: string) => {
    try {
        JSON.parse(string);
        return true;
    } catch (e) {
        return false;
    }
};

export const isXml = (string: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(string, "application/xml");
    return doc.getElementsByTagName("parsererror").length === 0;
};
